import { Component, OnInit, Input, ViewChild, OnDestroy, ElementRef, isDevMode } from '@angular/core';
import { StageSandbox } from '../../services/stage.sandbox';

import * as stageTypes from '../../types';
import * as animations from '../../../shared/animations';
import * as commonTypes from '../../../shared/types';
import * as _ from 'lodash';
import { CountDownTimerComponent } from '../../components/count-down-timer/count-down-timer.component';
import { Subscription } from 'rxjs/Rx';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { conformToMask } from 'angular2-text-mask';
import { PopNotificationService } from '../../../shared/services/pop-notification.service';
import { BlockUIService } from 'ng-block-ui';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'tr-mobile-number-confirmation',
  templateUrl: './mobile-number-confirmation.component.html',
  //styleUrls: ['./mobile-number-confirmation.component.scss']
})
export class MobileNumberConfirmationComponent implements OnInit, OnDestroy {
  @Input() entity: stageTypes.IPage;
  @Input() additional: stageTypes.IMobileStageResponse;
  private blockUI_target = 'stage-section';
  private pageContent: stageTypes.IHtmlElement;
  private mobileNumber: string;
  private subscriptions: Subscription[] = [];
  private mobileMask = [/[0]/, /[1-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  private digitMask = [/[0-9]/];

  private reSendClicks: number = 1;

  @ViewChild(CountDownTimerComponent) timer: CountDownTimerComponent;
  @ViewChild('first') first: ElementRef;
  @ViewChild('second') second: ElementRef;
  @ViewChild('third') third: ElementRef;
  @ViewChild('fourth') fourth: ElementRef;

  private inputs: string[] = ['first', 'second', 'third', 'fourth'];
  private currentFocusInput: string = 'first';

  private mobileNumberRegex = /(Didn't receive the code\? We sent it to )(.*)$/;
  private finaliseText = 'We are finalising the process - please wait a few moments.';

  private restrictedCountries: string[] = (!environment.production) ? [] : ['au'];
  private preferredCountries: string[] = (!environment.production) ? ['au'] : [];
  constructor(private sb: StageSandbox, private modalService: NgbModal, private notificationSvc: PopNotificationService, private blockUI: BlockUIService) {}

  ngOnInit() {
    this.pageContent = this.entity.htmlelements[0];
    this.mobileNumber = this.additional.mobile;

    setTimeout(() => {
      this.timer.startTimer();
    }, 0);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  processMobileNumber(str: string): string {
    const testRegex = str.match(this.mobileNumberRegex);
    if (testRegex && testRegex.length === 3) {
      return `${testRegex[1]}${this.mobileNumber}`;
    }
    return str;
  }

  onTimerFinished(isFinished: boolean) {
    if (isFinished) {
      this._resetInputs();
    }
  }

  alert(type: string, message: string): void {
    const errorObj: commonTypes.IToastr = {
        type: type,
        title: '',
        body: message
    };
    this.notificationSvc.popNotification(errorObj);
  }


  verifyCode(numbers: number[]) {
    this.timer.pauseTimer();
    this.blockUI.start(this.blockUI_target, this.finaliseText);
    this.sb.verifyCode$(numbers.join(''), this.additional.smssecret).take(1)
    .subscribe( (response) => {
      this.blockUI.stop(this.blockUI_target);
      if (_.has(response, 'error') && response['error']) {
        this.alert('error', response['detail']['message']);
        //setTimeout(() => {
          this.timer.resumeTimer();
        //}, 0);
      } else {
        this.sb.resetCurrentStageId();
      }
    });
  }

  onResend() {
    if (!this.mobileNumber || (this.mobileNumber && this.mobileNumber.replace(/_/g, '').trim() === '')) {
      this.alert('error', 'Sorry, the verification message cannot be sent as we don\'t have your mobile number.');
    } else {

      if (this.reSendClicks <= 3) {
        this.sb.resendSMS$(this.mobileNumber, this.additional.smssecret).take(1)
          .subscribe( (response) => {
            if (_.has(response, 'error') && response['error']) {
              this.alert('error', response['detail']['message']);

            } else {
              this.alert('info', `Message sent to number: ${this.mobileNumber}`);
              this.additional = (<stageTypes.IMobileStageResponse>response);
              this._resetInputs();
              this.reSendClicks ++;
              this.timer.initTimer();
              this.timer.startTimer();
            }
          });
      }
    }
  }

  _resetInputs() {
    this.first.nativeElement.value = '';
    this.second.nativeElement.value = '';
    this.third.nativeElement.value = '';
    this.fourth.nativeElement.value = '';

    this.first.nativeElement.focus();
  }

  jumpTo(currentInput: string): void {
    if (this[currentInput].nativeElement.value &&
      this[currentInput].nativeElement.value !== '') {
      const currentIndex = _.indexOf(this.inputs, currentInput);
      let nextIndex = currentIndex + 1;
      if (nextIndex === this.inputs.length) {
        nextIndex = this.inputs.length - 1;
      }
      this[this.inputs[nextIndex]].nativeElement.focus();
    }
  }

  conformedNumber() {
    return conformToMask(
      this.mobileNumber,
      this.mobileMask,
      {
        guide: true, showMask: true, keepCharPositions: false
      }
    ).conformedValue;
  }

  openDialog(content) {
    this.modalService.open(content).result.then((result) => {
      setTimeout(() => {
        this.mobileNumber = result.replace(/_/g, '').trim(); this.onResend();
      });
    }, (reason) => {
      // not doing anything
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/mobile-number-confirmation/mobile-number-confirmation.component.ts